import { FunctionField, useTranslate } from "react-admin";

import { PatientRecord } from "../../types/patient";

interface GenderFieldProps {
  source?: string;
  label: string;
  sortable?: boolean;
}

export const GenderField = ({ source = "gender", label = "Geschlecht", sortable = false }: GenderFieldProps) => {
  const translate = useTranslate();

  return (
    <FunctionField
      source={source}
      label={label}
      sortable={sortable}
      render={(record: PatientRecord) => translate(`gender.${record.gender}`)}
    />
  );
};
